<template>
  <el-card v-loading="tableLoading">
    <el-row>
      <el-form :model="form" v-bind="formProps.form" :rules="{}">
        <el-form-item :label="$t('channel.label.channelType')" prop="channelType">
          <el-select v-model="form.channelType">
            <el-option v-for="item in channelTypeList" :key="item" :value="item"> </el-option>
            <el-option :label="$t('btns.emptyValue')" value=""></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="channelCodeList" :label="$t('channel.label.channelCode')" prop="channelCode">
          <el-select v-model="form.channelCode">
            <el-option v-for="item in channelCodeList" :key="item" :value="item"> </el-option>
            <el-option :label="$t('btns.emptyValue')" value=""></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('channel.label.status')" prop="status">
          <el-select v-model="form.status">
            <el-option v-for="item in this.statusData" :key="item.label" :label="item.label" :value="item.value">
            </el-option>
            <el-option :label="$t('btns.emptyValue')" value=""></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('channel.label.createAcct')" prop="createAcct">
          <el-input v-model="form.createAcct" />
        </el-form-item>
        <el-form-item :label="$t('channel.label.createTime')" prop="createTime">
          <el-date-picker v-model="form.createTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>

        <el-form-item :label="$t('channel.label.name')" prop="name">
          <el-input v-model="form.name" />
        </el-form-item>

        <el-form-item>
          <el-button size="mini" type="warning" @click="handleEmpty()">{{
            $t('btns.empty')
            }}</el-button>
          <el-button size="mini" type="primary" @click="handleSearch()">{{
            $t('btns.search')
            }}</el-button>
          <el-button size="mini" type="primary" @click="handleEditor()">{{
            $t('btns.add')
            }}</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <el-row>
      <el-table :data="tableList" :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ textAlign: 'center' }"
        stripe>
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column width="200px" prop="channelCode" align="center" :label="$t('channel.label.channelCode')" />
        <el-table-column width="200px" prop="channelType" align="center" :label="$t('channel.label.channelType')" />
        <el-table-column width="200px" prop="createAcct" align="center" :label="$t('channel.label.createAcct')" />
        <el-table-column width="200px" prop="name" align="center" :label="$t('channel.label.info')" />
        <el-table-column width="220px" prop="sort" align="center" :label="$t('channel.label.sort')" />
        <el-table-column width="120px" prop="status" align="center" :label="$t('channel.label.status')">
          <template slot-scope="{ row }">
            <p>
              <el-tag v-for="item in statusData" :key="item.label" :type="item.type" v-show="item.value === row.status">
                {{ item.label }}
              </el-tag>
            </p>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('channel.label.action')">
          <template slot-scope="{ row }">
            <el-popconfirm :ref="`popover-${row.id}`" :key="row.id" :title="$t('orders.tip.danger')"
              @confirm="handleEditor(row)">
              <el-button slot="reference" type="primary" size="mini">
                {{ $t('btns.editor') }}
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <v-pagination v-model="pagination" :total="tableData.rows" @update="getTableData" />

    <v-editor ref="editor" :statusData="statusData"  :rules="formProps.form.rules"
      :channelTypeList="channelTypeList" :channelTypeData="channelTypeData" @doConfAdd="doConfAdd"
      @doConfUpdate="doConfUpdate" />
  </el-card>
</template>

<script>
  import {
    debounce
  } from 'lodash';
  import channelApi from '@/api/channel';
  import vEditor from './editor';
  export default {
    name: 'channelConf',
    components: {
      vEditor
    },
    data() {
      return {
        tableLoading: false,
        form: {
          channelCode: '',
          channelType: '',
          createAcct: '',
          createTime: '',
          name: '',
          serviceType: '',
          status: ''
        },
        pagination: {
          no: 1,
          size: 100
        },

        channelTypeData: {},
        tableData: {}
      };
    },
    computed: {
      tableList() {
        return this.tableData.list || [];
      },
      channelTypeList() {
        return Object.keys(this.channelTypeData) || [];
      },
      channelCodeList() {
        if (Array.isArray(this.channelTypeData[this.form.channelType])) {
          return this.channelTypeData[this.form.channelType].length > 0 ?
            this.channelTypeData[this.form.channelType] :
            '';
        } else {
          return '';
        }
      },
      statusData() {
        return [{
            label: this.$t('status.success2'),
            type: 'success',
            value: 1
          },
          {
            label: this.$t('status.error2'),
            type: 'error',
            value: 0
          }
        ];
      }
    },
    created() {
      this.init();
    },
    mounted() {
      this.getConfType();
      this.getTableData();
    },
    methods: {
      init() {
        this.handleSearch = debounce(this._handleSearch, 300);

        /* ----------------------------- element -props ----------------------------- */
        this.formProps = {
          form: {
            ref: 'form',
            'label-width': 'auto',
            inline: true,
            size: 'small',
            rules: {
              channelCode: [{
                required: true,
                message: this.$t('channel.rules.channelCode'),
                trigger: 'change'
              }],
              channelType: [{
                required: true,
                message: this.$t('channel.rules.channelType'),
                trigger: 'change'
              }]
            }
          }
        };
        
      },

      /* ---------------------------------- 格式化数据 --------------------------------- */
      formatParams() {
        return {
          ...Object.keys(this.form).reduce((acc, key) => {
            if (this.form[key] === 0 || this.form[key]) {
              acc[key] = this.form[key];
            }
            if (!this.channelCodeList) {
              acc.channelCode = '';
            }
            return acc;
          }, {})
          // ...this.pagination
        };
      },
      /* --------------------------------- 获取分页数据 --------------------------------- */
      async getTableData() {
        this.tableLoading = true;
        const {
          data
        } = await channelApi.confPage({
          data: {
            query: this.formatParams(),
            no: this.pagination.no,
            size: this.pagination.size
          }
        });
        if (data && data.code == 200) {
          this.tableData = data.data;
          this.tableLoading = false;
        } else {
          this.$message.error(data.msg);
          this.tableLoading = false;
        }
      },
      async getConfType() {
        const {
          data
        } = await channelApi.confType();
        if (data && data.code == 200) {
          this.channelTypeData = data.data;
        }
      },

      async doConfAdd(formUpdate, cb) {
        const params = {
          ...formUpdate
        };
        const {
          data
        } = await channelApi.confAdd(params);
        if (data.success) {
          cb();
        } else {
          this.$message.error(data.message);
        }
        // this.tableData = res.data.data;
        this.getTableData();
      },

      async doConfUpdate(formUpdate, cb) {
        const params = {
          ...formUpdate
        };
        const {
          data
        } = await channelApi.confUpdate(params);
        if (data.success) {
          cb();
        } else {
          this.$message.error(data.message);
        }
        // this.tableData = res.data.data;
        this.getTableData();
      },
      /* --------------------------------- 事件驱动函数 --------------------------------- */
      handleEmpty() {
        this.form = {
          channelCode: '',
          channelType: '',
          createAcct: '',
          createTime: '',
          name: '',
          serviceType: '',
          status: ''
        };
        this.pagination = {
          no: 1,
          size: 100
        }
      },
      handleEditor(row) {
        this.$refs.editor.init(row);
      },
      _handleSearch() {
        this.$refs.form.validate(async (valid) => valid && this.getTableData());
      }
    }
  };

</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/channel-conf/index.vue